document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('myModal');
  const btn = document.getElementById('myBtn');
  const btn2 = document.getElementById('myBtn2');
  const closeButtons = document.querySelectorAll('.close');

  if (!modal) return;

  function openModal() {
    modal.style.display = 'block';
  }

  function closeModal() {
    modal.style.display = 'none';
  }

  if (btn) btn.addEventListener('click', openModal);
  if (btn2) btn2.addEventListener('click', openModal);

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closeModal);
  });

  window.addEventListener('click', function (event) {
    if (event.target === modal) {
      closeModal();
    }
  });
});
